<!-- =========================================================================================
  File Name: OrderView.vue
  Description: Order View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-ordersheet-view">

    <vs-alert color="danger" title="Order Not Found" :active.sync="order_not_found">
      <span>Order record with orderSheetSeq: {{ $route.params.orderSheetSeq }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'order-list'}" class="text-inherit underline">All Orders</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="order_data">

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="주문정보">
            <div class="tab-text">
              <orderSheet-view-tab-information class="mt-4" :data="order_data" />
            </div>
          </vs-tab>
          <vs-tab v-if="isShowPayInfo" label="결제정보">
            <div class="tab-text">
              <orderSheet-view-tab-pay class="mt-4" :data="order_data" />
            </div>
          </vs-tab>
          <vs-tab v-if="isShowTrackingInfo"  label="배송정보">
            <div class="tab-text">
              <orderSheet-view-tab-tracking class="mt-4" :data="order_data" />
            </div>
          </vs-tab>
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import OrderSheetViewTabInformation from './OrderSheetViewTabInformation.vue'
import OrderSheetViewTabPay from './OrderSheetViewTabPay.vue'
import OrderSheetViewTabTracking from './OrderSheetViewTabTracking.vue'

import { fetchData } from '@/api/module'

export default {
  components: {
    OrderSheetViewTabInformation,
    OrderSheetViewTabPay,
    OrderSheetViewTabTracking
  },
  data () {
    return {
      order_data: null,
      order_not_found: false,
      activeTab: 0,
      isShowPayInfo: true,
      isShowTrackingInfo: true
    }
  },
  watch: {
    activeTab () {
      this.fetch_order_data()
    }
  },
  methods: {
    async fetch_order_data () {
      try {
        const orderSheetSeq = this.$route.params.orderSheetSeq
        const { data } = await fetchData(`order/${orderSheetSeq}`)
        this.order_data = data.data

      } catch (error) {
        
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  },
  created () {
    this.fetch_order_data()   
    const userType = this.$store.getters.getUserInfo.userType
    if (userType !== 'sysadmin') {
      this.isShowPayInfo = false
      this.isShowTrackingInfo = false
    }
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-order-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

}

</style>
